<template>
  <router-view></router-view>
</template>

<script>
export default {
  data() {
    return {
      authenticated: false
    };
  },
  methods: {}
};
</script>

<style lang="scss">
@import url("https://use.typekit.net/jng1ima.css");
@import "src/styles/amaze";
@import "src/styles/amaze-redesign";
</style>
